import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import bearData from "../assets/bear-data";
import {colors, sections} from "../assets/settings";
import Gem from "./elements/Gem";

bearData.forEach((circle, i) => {
    circle._color = circle.color;
    circle._size = circle.size;
    circle._x = circle.x;
    circle._y = circle.y;
});

let layoutMemoize = '';
const bgCircles = [];
const mainCircles = [];

function Bear(props) {
    const {progress, openAmount, selectedIndices, scrollAmount, store} = props;
    const {interactionsStore} = store;
    const svgScale = interactionsStore.mobileMode ? 0.75 : 1;

    const getCircleY = (num) => {
        return top + num * 50;
    };

    const circleCenterX = 25;
    const bearOffset = {
        x: interactionsStore.mobileMode ? 100 : 160,
        y: 150
    };

    const setTooltipIndex = (idx) => {
        interactionsStore.setTooltipIndex(idx);
    };

    const scale =  0.8;
    const bearScale = Math.min(1.2, document.documentElement.clientWidth / 400);
    const navHt = 400;

    const top = ((document.documentElement.clientHeight - navHt) / 2) / svgScale;
    const memoize = `${top}_${navHt}_${scale}`;
    if (memoize !== layoutMemoize) {
        layoutMemoize = memoize;
        bgCircles.length = 0;
        mainCircles.length = 0;
        bearData.forEach((circle, i) => {
            if (!circle.x && !circle.y) return;
            if (circle._color === '#46535E') {
                circle.color = '#ffffff';
                circle.start = {x: Math.random() * 50, y: top + Math.random() * navHt};
                bgCircles.push(circle);
            } else {
                let idx = circle.id;
                circle.color = colors[idx];
                circle.start = {x: circleCenterX, y: getCircleY(idx)};
                mainCircles.push(circle);
                circle.section = sections[idx - 1];//Note sections not aligned with circles idx (circles start at 1)
            }
            circle.size = circle._size;
            circle.x = bearOffset.x + circle._x * bearScale;
            circle.y = top + bearOffset.y + circle._y * bearScale;
        });
    }

    const clampedProgress = Math.max(0, Math.min(progress, 1));
    const tweenX = (circle) => {
        return circle.start.x + clampedProgress * (circle.x - circle.start.x)
    };
    const tweenY = (circle) => {
        return circle.start.y + clampedProgress * (circle.y - circle.start.y)
    };
    const mainCircleX = (circle) => {
        const idx = circle.id;
        if (openAmount < 1) {
            return circle.start.x + 10 * -idx * (1 - openAmount);
        }
        if (selectedIndices && selectedIndices.indexOf(idx) >= 0) {
            return tweenX(circle);
        }
        return circle.start.x;
    };
    const mainCircleY = (circle) => {
        const idx = circle.id;
        if (selectedIndices && selectedIndices.indexOf(idx) >= 0) {
            return tweenY(circle);
        }
        return circle.start.y;
    };

    const gathered = (circle) => {
        const idx = circle.id;
        return (selectedIndices && selectedIndices.indexOf(idx) >= 0);
    };

    const scrollToId = (id) => {
        const el = document.querySelector(`#${id}`);
        if (el) {
            el.scrollIntoView();//{behavior: 'smooth'}
        }
    };

    const onGemClick = (circle) => {
        const {section} = circle;
        if (!section) return;
        scrollToId(`${section.key}_header`);
    };

    const toolTip = (pos, color, title) => {
        const style = {};//Note this doesn't work on IE and looks okay without: filter: 'url(#shadow)'};
        return (<g transform={`translate(${pos.x},${pos.y})`}>
            <path fill={color} style={style}
                  d={'M -8.7949641,-17.748466 C -12.320113,-13.329873 -15.845257,-8.9113094 -19.370404,-4.4927153 -18.112239,1.0169288 -16.854068,6.526601 -15.595902,12.036237 -10.046597,14.327176 -4.8132624,18.002836 0.94161933,19.392779 94.284337,19.417676 187.67669,19.34043 280.98488,19.436236 284.50952,15.018183 288.03415,10.60011 291.55877,6.1820595 290.30112,0.67187589 289.04348,-4.8383088 287.78584,-10.348464 282.40575,-12.667217 276.71239,-16.22869 271.53665,-17.748466 178.09278,-17.748466 84.648908,-17.748466 -8.7949641,-17.748466 Z'}/>
            <text style={{'fontSize':19, fill:'white'}} x={6.5} y={8.5}>{title}</text>
        </g>);
    };

    const renderToolTip = () => {
        if (interactionsStore.tooltipIndex < 0) return null;
        const circle = mainCircles[interactionsStore.tooltipIndex];
        const pos = {
            x: circleCenterX,
            y: circle.start.y,
        };
        return toolTip(pos, circle.color, circle.section.title);
    };

    const width = 50;

    const markerPos = {
        x: openAmount * width - 1,
        y: getCircleY(scrollAmount),
    };
    if (scrollAmount === -1) {
        markerPos.y = top + navHt - 30;
        markerPos.x = width;
    }
    return (
        <Fragment>
            <svg className={'Bear'} style={{height: document.documentElement.clientHeight}}>
                <defs>
                    <filter id="shadow">
                        <feDropShadow dx="1" dy="1" stdDeviation="3"/>
                    </filter>
                </defs>
                <g transform={`scale(${svgScale})`}>

                    <g transform={`translate(${-width + openAmount * width},0)`}>
                        {progress > 0 && bgCircles.map((c, i) => <circle key={`c${i}`}
                                                                         cx={tweenX(c)}
                                                                         cy={tweenY(c)}
                                                                         fill={c.color}
                                                                         r={c.size}
                        />)}
                        {progress <= 0 && <Fragment>
                            <path id="marker" transform={`translate(${markerPos.x},${markerPos.y})`}
                                  fill="#ffffff"
                                  d="M 0,35 17.5,17.5 0,0 Z"/>
                            <rect fill={'#ffffff'} y={top - 18} width={50} height={436}/>
                        </Fragment>}
                        <Gem
                            cx={circleCenterX}
                            cy={getCircleY(0) + 8}
                            activated={true}
                            progress={0}
                            fill={colors[0]}
                            r={10}
                            onClick={() => {
                                scrollToId(`toc`);
                            }}
                        />
                        {mainCircles.map((c, i) => <Gem
                            key={`gem_${i}`}
                            cx={mainCircleX(c)}
                            cy={mainCircleY(c)}
                            strength={8}
                            activated={gathered(c)}
                            progress={selectedIndices.length}
                            stroke={c.color}
                            fill={c.color}
                            r={c.size - 1}
                            onMouseEnter={() => {
                                setTooltipIndex(i)
                            }}
                            onMouseLeave={() => setTooltipIndex(-1)}
                            onClick={() => {
                                onGemClick(c);
                            }}
                        />)}
                        <Gem
                            cx={circleCenterX}
                            cy={getCircleY(mainCircles.length + 1) - 8}
                            activated={true}
                            progress={0}
                            fill={'#dcd5c6'}
                            r={10}
                            onClick={() => {
                                scrollToId(`about-you`);
                            }}
                        />
                        {renderToolTip()}
                    </g>
                </g>
            </svg>
        </Fragment>
    );
}

export default observer(Bear);
